export const formatDate = (dateValue: string) => new Date(dateValue).toLocaleDateString('tr-TR')
